import { Ref, forwardRef } from "react"
import { Form, Formik, FormikProps } from "formik"
import * as yup from "yup"
import { CreateUpdateDepartment, HistoryType } from "../departmentsTypes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { CreateUpdateDepartmentFormContent } from "./CreateUpdateDepartmentFormContent"

type CreateUpdateDepartmentFormProps = Readonly<{
    initialValues?: CreateUpdateDepartment | null
    history?: HistoryType
    onSubmit: (formData: CreateUpdateDepartment) => void
}>
type FormikRef = Ref<FormikProps<CreateUpdateDepartment>>

export const CreateUpdateDepartmentForm = forwardRef(
    ({ initialValues, history, onSubmit }: CreateUpdateDepartmentFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const defaultInitialValues = {
            departmentNo: "",
            name: "",
            isActive: true,
        }

        const validationSchema = yup.object({
            name: yup.string().required(l10n.getString("create-or-edit-company-department-field-is-required")),
        })

        function handleSubmit(values: CreateUpdateDepartment) {
            onSubmit(values)
        }

        return (
            <>
                <Formik<CreateUpdateDepartment>
                    enableReinitialize
                    initialValues={initialValues ? initialValues : defaultInitialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    innerRef={ref}
                >
                    <Form>
                        <CreateUpdateDepartmentFormContent history={history} />
                    </Form>
                </Formik>
            </>
        )
    },
)
